import FlexContainer from 'core-system/FlexContainer'
import CheckmarkIcon from 'core-system/Icons/Actions/Checkmark'
import ProgramUtils from 'core-system/Program/ProgramUtils'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import React from 'react'
import RandomUtils from 'shared/RandomUtils'
import styled from 'styled-components'

const Container = styled.div`
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
`

const Options = styled.div`
  margin-top: 1.5rem;
  padding: 0 0.5rem;
`

const Option = styled.div`
  margin-top: 1.25rem;
  padding-top: 1.5rem;
  border-top: 1px solid ${(props) => props.theme.palette.grey.grey400};

  &:first-of-type {
    border-top: none;
    margin-top: 0;
    padding-top: 0;
  }

  &:last-of-type {
    margin-bottom: 0.5rem;
  }
`

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`

const OptionProviders = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.5rem;
`

interface SummaryOptionsProps {
  icon: React.ReactNode
  activeOptions: {
    type: string
    activeMerchantIds: string[]
    active: boolean
  }[]
}

const SummaryOptions = React.memo((props: SummaryOptionsProps) => {
  const { icon, activeOptions } = props

  const noActiveOptions = Object.keys(activeOptions).every(
    (option) => !activeOptions[option]
  )

  return (
    <Container>
      <HeaderContainer>
        {icon}
        <Text variant='action3' marginLeft='0.5rem'>
          Program Options
        </Text>
      </HeaderContainer>
      {noActiveOptions ? (
        <Text
          variant='body2'
          marginTop='0.5rem'
          textColor={palette.text.secondary}
        >
          No options are selected for this program
        </Text>
      ) : (
        <Options>
          {activeOptions.map((option, index) => {
            if (!option.active) return null
            return (
              <Option key={index}>
                <FlexContainer
                  alignItems='center'
                  justifyContent='space-between'
                >
                  <Text
                    variant='action3'
                    textColor={palette.text.secondary}
                    captionTitle
                  >
                    {ProgramUtils.optionsCopy[option.type].title}
                  </Text>
                  <CheckmarkIcon
                    width={13}
                    height={13}
                    color={palette.secondary.purple600}
                  />
                </FlexContainer>
                {option.activeMerchantIds &&
                  option.activeMerchantIds.length > 0 && (
                    <OptionProviders>
                      <Text variant='action4'>
                        {option.activeMerchantIds.length} Service Provider
                        {RandomUtils.pluralCheck(
                          option.activeMerchantIds.length
                        )}
                      </Text>
                    </OptionProviders>
                  )}
              </Option>
            )
          })}
        </Options>
      )}
    </Container>
  )
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  SummaryOptions.displayName = 'SummaryOptions'
}

export default SummaryOptions
